<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-secondary)]">
    <div class="p-4">
      <main class="h-full flex items-center justify-start mx-auto max-w-[720px]">
        <div class="flex flex-col w-full">
          <VaTabs v-model="selectedTabIndex" @update:modelValue="tabIndex = $event">
            <VaTab v-for="tab in tabs" :key="tab.name" :name="tab.name">
              {{ t(tab.labelI18nKey) }}
            </VaTab>
          </VaTabs>
          <VaSeparator />
          <div class="pa-3">
            <RouterView />
          </div>
        </div>
      </main>
    </div>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'
import { computed, watch, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()
const { t } = useI18n()
const selectedTabIndex = ref(0)
const tabs = [
  { name: 'login', labelI18nKey: 'auth.login' },
  { name: 'signup', labelI18nKey: 'auth.createNewAccount' },
]
const tabIndex = computed({
  get: () => route.name,
  set: (tabName) => {
    router.push({ name: tabName })
  },
})
watch(
  () => route.name,
  (newName) => {
    const index = tabs.findIndex((t) => t.name === newName)
    if (index !== -1) selectedTabIndex.value = index
  },
)
const breakpoint = useBreakpoint()
</script>
